import Phaser from "phaser"
import { cScene } from "../cScene";
import { ScreenItem } from "../dataTypes";
import { ModuleCollection, Base } from "./../cGameObjects/modules";

export class Landscape extends Phaser.GameObjects.Container {

  public modules: ModuleCollection;
  private _data: ScreenItem;
  private _extraData: any;
  private scapes:Phaser.GameObjects.Container[] = []
  private cc: number = 0
  private _speed: number = 5;

  private frameWidth:number = 1920;
  private scapelist: Phaser.GameObjects.Sprite[] = []
  private isFirst: boolean = true;

  private behindContainer: Phaser.GameObjects.Container;
  private infrontContainer: Phaser.GameObjects.Container;
  private bgContainer: Phaser.GameObjects.Container;
  private bgs: Phaser.GameObjects.Sprite[] = [];

  private tx:Phaser.Textures.Texture;

  private fixedItemWidth: number = -1;

  private lastFrame: string = '';
  private frameNames: String[];
  private followItems: any;

  private shiftTable:any = {
  }

  constructor(sc:cScene, data: ScreenItem){
    super(sc,0,0);
    //, parseAssetName(data.asset,'asset') || '', parseAssetName(data.asset,'frame')
    this._data = data;
    this.modules = Base.initModules(this,data)

    //behind container
    this.behindContainer = new Phaser.GameObjects.Container(this.scene,0,0);
    this.infrontContainer = new Phaser.GameObjects.Container(this.scene,0,0);

    try {
      this._extraData = JSON.parse( String(data.objectdata) )
    }catch (e){
      console.warn('JSON ERRRO IN Extra Data')
      this._extraData = {'parser_error':1}
    }

    this.tx = this.scene.textures.get( String(this._data.asset) );
    this.shiftTable = this._extraData.shiftTable || [];
    this.frameNames = Object.keys( this.shiftTable )

    if (this._extraData.shiftY) this.behindContainer.y = this.infrontContainer.y = Number(this._extraData.shiftY);
    if (this._extraData.follow) {
      this.followItems = this._extraData.follow;
    }

    this.fixedItemWidth = this._extraData.item_width ? Number(this._extraData.item_width) : -1;

    //setup background
    this.bgContainer = new Phaser.GameObjects.Container(this.scene,0,0);    
    if (this._extraData.bg && Array.isArray(this._extraData.bg)){
      var $this = this;
      this._extraData.bg.forEach( (nm:string)=>{
        $this.bgs.push( new Phaser.GameObjects.Sprite( this.scene,0,0, String(this._data.asset), nm)  )
      })
    }
    this.bgs.forEach( el=>{
      el.scale=2;
      el.y = -40;
      el.setOrigin(0,0);
      this.bgContainer.add(el)
    });
    this.flipBackground();

    this.add(this.behindContainer);
    this.add(this.bgContainer);
    this.add(this.infrontContainer);


    var wi = 0;
    const appendWidth = (el:any) => {
      wi += (el as any).itemWidth
    }


    while (wi < 1920+720){
      this.appendScape();
      wi = 0;
      this.scapelist.map( appendWidth )      
    }
    this.alignItems();

    if (!sc.debugMode){
      sc.events.on('render',()=>{
        this.update();
      })    
    }
  }

  flipBackground (){
    if (this.bgs.length > 0){
      var g = this.bgs.shift()
      this.bgs.push(g as any);
      this.bgs[0].x = 0;
      this.bgs[1].x = 1920;  
    }
  }


  update(...args: any[]): void {
    this.cc = (this.cc - this._speed)

    //move backgroiund
    this.bgContainer.x = (this.bgContainer.x - this._speed);
    if (this.bgContainer.x < -this.frameWidth){
      this.bgContainer.x += this.frameWidth;
      this.flipBackground();

    }

    this.infrontContainer.x -= this._speed;    

    if (this.infrontContainer.x < -(this.scapelist as any)[0].itemWidth ){
      var first:any = this.scapelist.shift();
      this.infrontContainer.x += first.itemWidth;
      first.destroy();

      this.appendScape();
      this.alignItems();
    }

    this.behindContainer.x = this.infrontContainer.x;
  }

  rndlen(l:number):number{
    return Math.floor(Math.random() * l)
  }

  alignItems(){
    var xx = 0;
    this.scapelist.forEach( el=>{
      el.x = xx;
      xx += (el as any).itemWidth;
    })

  }

  appendScape(){

    var fr:string

    if (this.followItems){
      if (this.lastFrame){
        var fo = this.followItems[ this.lastFrame ];
        fr = fo[ this.rndlen(fo.length) ]
        this.lastFrame = fr;
      }else{
        fr = String(this.frameNames[ this.rndlen(this.frameNames.length) ]);    
        this.lastFrame = fr;
      }
    }else{
      var next = Math.floor( Math.random() * this.frameNames.length );
      fr = String(this.frameNames[next]);      
    }

    var newScapeItem = new Phaser.GameObjects.Sprite( this.scene,0,0, String(this._data.asset), fr)
    newScapeItem.scale=2
    newScapeItem.setOrigin(0,0.5);
    newScapeItem.y = this.shiftTable[fr] || 0;
    
    if (['nadelwald'].indexOf(fr) !== -1){
      this.behindContainer.add( newScapeItem );
    }else{
      this.infrontContainer.add( newScapeItem );
    }
    
    //newScapeItem.alpha = 0.2;

    if (this.fixedItemWidth !== -1){    
      let w =  Math.floor(newScapeItem.displayWidth / this.fixedItemWidth);
      (newScapeItem as any).itemWidth =  (w === 0 ? 2 : w+1) * this.fixedItemWidth
    }else{
      (newScapeItem as any).itemWidth = newScapeItem.displayWidth;
    }

    this.scapelist.push( newScapeItem );   
  }


  public get speed(): number {
    return this._speed * 100;
  }
  public set speed(value: number) {
    this._speed = value / 100;
    //console.log(value,"---",this._speed);
  }


}